import { Typography } from "../../components";
import { Box } from "@mui/material";

const LabelValue = ({
    key,
    label,
    children
}: {
    key: string;
    label: string;
    children: React.ReactNode;
}) => {
    return (
        <Box key={key} gap={1} flexDirection="column" display="flex">
            <Typography type="s3" weight="bold" color="theme.secondary.1000">{label}</Typography>
            {children}
        </Box>
    )
}

export { LabelValue };
export default LabelValue